import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import { getVersion } from "./api";
import { envKindFor, ENV_BANNERS } from "./env";
import ProductPage from "./pages/ProductPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import Admin from "./pages/Admin";

// neprodukční prostředí (test / feature) poznáme z adresy — viz env.js
const ENV_KIND = envKindFor(typeof window !== "undefined" ? window.location.hostname : "");
const ENV_BANNER = ENV_BANNERS[ENV_KIND];

function App() {
  // verze nasazeného balíčku (BE ji čte z CN_PACKAGE_VERSION); lokálně/při chybě se neukáže
  const [appVersion, setAppVersion] = useState("");
  useEffect(() => {
    getVersion()
      .then((d) => setAppVersion((d && d.version) || ""))
      .catch(() => {});
  }, []);

  return (
    <BrowserRouter>
      {/* neprodukční prostředí: banner drží nahoře i při scrollu + celé pozadí je tónované */}
      <div className={ENV_BANNER ? `env-${ENV_KIND}` : ""}>
      {ENV_BANNER && (
        <div className={`test-banner banner-${ENV_KIND}`}>{ENV_BANNER}</div>
      )}
      <header className="topbar">
        <Link to="/" className="brand">🧦 Ponožky</Link>
      </header>
      <main className="container">
        <Routes>
          <Route path="/" element={<ProductPage />} />
          <Route path="/objednavka/potvrzeni" element={<ConfirmationPage />} />
          <Route path="/admin/*" element={<Admin />} />
        </Routes>
      </main>
      <footer className="footer">
        <div>
          E-shop · edukační projekt{appVersion ? ` · verze ${appVersion}` : ""} ·{" "}
          <Link to="/admin" className="footer-admin">administrace</Link>
        </div>
        <div className="footer-credit">
          Postaveno na cloud-native platformě{" "}
          <a href="https://www.codenow.com" target="_blank" rel="noreferrer">CodeNOW</a>
          {" "}— navrženo a implementováno AI agentem <strong>ttnz</strong>.
        </div>
      </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
